// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { ComplianceService } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Compliance';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorBasedQuery } from '../../useOperatorBasedQuery';

const useComplianceServices: () => UseQueryResult<
  TemplateContract<ComplianceService>[],
  string
> = () =>
  useOperatorBasedQuery('queryComplianceServices', (ledgerApi, offset, operator) =>
    ledgerApi.queryComplianceServices(offset, operator),
  );

export default useComplianceServices;
